import { format } from 'date-fns';
import { subtractPeriod } from 'utils/utils';
export function formatPeriod(period, isOlderThan) {
  if (period === '7') {
    period = 'week';
  } else if (period === '30') {
    period = 'month';
  } else if (period === '365') {
    period = 'year';
  }
  var date = format(subtractPeriod(period), 'yyyy-MM-dd');
  if (isOlderThan) {
    return "..".concat(date);
  } else {
    return "".concat(date, "..");
  }
}